import React, { Suspense } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ScrollToTop from "./Component/ScrollToTop";
import { ReactNotifications } from "react-notifications-component";
import PageWithLoader from "./PageWithLoader";

import ProtectedRoute, {
  ProtectedLoginSign,
  ProtectedRouteAfterVendor,
} from "./ProtectedRoute";

import RendomTokenData from "./Store/StoreToken";
import Logout from "./Component/Login-Signup/Logout";

import LeadAdd from "./Component/Deshboard/Vendor/VendorLeads/LeadAdd";
import Leads from "./Component/Deshboard/Leads/Leads";
import LeadDetails from "./Component/Deshboard/Leads/LeadDetails";
import UserFormSubmission from "./Component/FormStepper/UserFormSubmission";

import PlanDetails from "./Component/Service/PlanDetails";
import LeadAssignView from "./Component/Deshboard/Vendor/VendorLeads/LeadAssignView";
import LeadsWorkingView from "./Component/Deshboard/Vendor/VendorLeads/LeadsWorkingView";
import LeadAssignDetails from "./Component/Deshboard/Vendor/VendorLeads/LeadAssignDetails";
import LeadWorkingDetails from "./Component/Deshboard/Vendor/VendorLeads/LeadWorkingDetails";
import CheckoutPlans from "./Component/Checkout/CheckoutPlans";
import VendorRequest from "./Component/Deshboard/Vendor/VendorRequest/VendorRequest";
import AllCatServiceWiseLeads from "./Component/Deshboard/AllCatServiceWiseLead/AllCatServiceWiseLeads";
import FreeLegalAdvice from "./Component/Community/FreeLegalAdvice";
import AskfreeQuestion from "./Component/Community/AskfreeQuestion";
import FreelegalAdvicePhone from "./Component/Community/FreelegalAdvicePhone";
import LegalAdviceDetails from "./Component/Community/LegalAdviceDetails";
import QuestionAnswereDetails from "./Component/Community/QuestionAnswereDetails";
import AllLeadtotalDetails from "./Component/Deshboard/AllCatServiceWiseLead/AllLeadtotalDetails";
import AllClaimLeads from "./Component/Deshboard/AllNoAssignLead/AllClaimLeads";
import AllClaimLeadDetails from "./Component/Deshboard/AllNoAssignLead/AllClaimLeadDetails";
import UserAutoLogout from "./UserAutoLogout";
// import ServiceDetails2 "./Component/Service/ServiceDetails2";
import NewsPaperSchedule from "./Component/Deshboard/Vendor/NewsPaperVendor/NewsPaperSchedule";
import NewsPaperScheduleEdit from "./Component/Deshboard/Vendor/NewsPaperVendor/NewsPaperScheduleEdit";
import NewsPaperScheduleView from "./Component/Deshboard/Vendor/NewsPaperVendor/NewsPaperScheduleView";

import Services from "./Component/Service/Services";
import ServiceDetails from "./Component/Service/ServiceDetails";
import Service from "./Component/Service/Service";
// import Deshbard from "./Component/Deshboard/Deshbard";

import Profile from "./Component/Deshboard/ProfileEdit/Profile";
import ProfileEdit from "./Component/Deshboard/ProfileEdit/ProfileEdit";
import Login from "./Component/Login-Signup/Login";
import Signup from "./Component/Login-Signup/Signup";
// import Blog from "./Component/Blog/Blog";
// import Blogs from "./Component/Blog/Blogs";
import PageNotFound from "./Component/404Page/PageNotFound";
import Wallet from "./Component/Deshboard/Wallet/Wallet";
import ForgotPassword from "./Component/Login-Signup/ForgotPassword";
// import ContactUS from "./Component/Pages/ContactUS";
// import About from "./Component/Pages/About";
// import Enquery from "./Component/Service/Enquiry";
import RefundPolicy from "./Component/TermsPrivacyPage/RefundPolicy";
import TermCondition from "./Component/TermsPrivacyPage/TermCondition";
import PrivacyPolicy from "./Component/TermsPrivacyPage/PrivacyPolicy";
import ProductServiceDescription from "./Component/TermsPrivacyPage/ProductServiceDescription";
import AllServicePlans from "./Component/Deshboard/DeshBoardPlans/AllServicePlans";
import ServicePlansAll from "./Component/Service/ServicePlansAll";
import NewsScheduleUpdate from "./Component/Deshboard/Vendor/NewsPaperVendor/NewsScheduleUpdate";
import Deshbard from "./Component/Deshboard/Deshbard";
import PaymentMethods from "./Component/Checkout/PaymentMethods";
import PaymentSuccess from "./Component/Checkout/PaymentSuccess";
import PaymentFeild from "./Component/Checkout/PaymentFeild";
import PaymentLinkwork from "./Component/Checkout/PaymentLinkwork";
import PaymentInvalid from "./Component/Checkout/PaymentInvalid";
import PaymentResponse from "./Component/Checkout/PaymentResponse";
import PaymentReceipt from "./Component/Checkout/PaymentReceipt";
import NewsPaperAdd from "./Component/Deshboard/Vendor/NewsPaperVendor/NewsPaperAdd";
import LeadTransactionDetails from "./Component/Deshboard/Transaction/LeadTransactionDetails";
import ErrorPage from "./Component/Pages/ErrorPage";
import AddtoCart from "./Component/Checkout/AddtoCart";
import CheckoutPlansdemo from "./Component/Checkout/CheckoutPlansdemo";
import NewsPaperAddView from "./Component/Deshboard/Vendor/NewsPaperVendor/NewsPaperAddView";
import Passbook from "./Component/Deshboard/Wallet/Passbook";
import AddWallet from "./Component/Deshboard/Wallet/AddWallet";
import AddWalletProceed from "./Component/Deshboard/Wallet/AddWalletProceed";
import WalletPaymentSuccess from "./Component/Deshboard/Wallet/WalletPaymentSuccess";
import PassbookTransactionDetails from "./Component/Deshboard/Wallet/PassbookTransactionDetails";
import SingleLeadTransactionDetails from "./Component/Deshboard/Transaction/SingleLeadTransactionDetails";
import WalletTransactions from "./Component/Deshboard/Wallet/WalletTransactions";
import WalletTransactionDetails from "./Component/Deshboard/Wallet/WalletTransactionDetails";
import WithdrawalAmount from "./Component/Deshboard/Wallet/WithdrawalAmount";
import AccountDetailsUpdate from "./Component/Deshboard/ProfileEdit/AccountDetailsUpdate";
import WithdrawalTransactionDetails from "./Component/Deshboard/Wallet/WithdrawalTransactionDetails";

const Header = React.lazy(() => import("./Component/Main/Header"));
const Footer = React.lazy(() => import("./Component/Main/Footer"));

const Home = React.lazy(() => import("./Component/Home/Home"));

// const Deshbard = React.lazy(() => import("./Component/Deshboard/Deshbard"));

function App() {
  // const [SidebarShow, setSidebarShow] = useState(false);

  // const UserSidebarShow = () => {
  //   SidebarShow === true ? setSidebarShow(false) : setSidebarShow(true);
  // };

  const RendomTokenfetch = RendomTokenData();
  // console.log(RendomTokenfetch);

  // useEffect(() => {
  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && e.key === "I") ||
  //       (e.ctrlKey && e.key === "U")
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   document.addEventListener("contextmenu", (e) => {
  //     e.preventDefault();
  //   });
  // }, []);

  // window.addEventListener("error", (e) => {
  //   if (
  //     e.message ===
  //     "ResizeObserver loop completed with undelivered notifications."
  //   ) {
  //     e.stopImmediatePropagation();
  //   }
  // });

  return (
    <>
      <Router>
        <UserAutoLogout />
        <ScrollToTop />
        <ReactNotifications />
        <PageWithLoader />
        <Suspense fallback={<PageWithLoader />}>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />

            {/* <Route
              path="/blog"
              element={<Blog RendomTokenfetch={RendomTokenfetch} />}
            /> */}

            {/* <Route
              path="/blogs/:language"
              element={<Blogs RendomTokenfetch={RendomTokenfetch} />}
            /> */}

            {/* <Route
            
            path="/:slug"
            element={<BlogDetails RendomTokenfetch={RendomTokenfetch} />}
          />
          <Route
            
            path="/:lang/:slug"
            element={<BlogDetails RendomTokenfetch={RendomTokenfetch} />}
          /> */}
            {/* <Route path="/contact" element={<ContactUS />} />
            <Route
              path="/about"
              element={<About RendomTokenfetch={RendomTokenfetch} />}
            /> */}
            <Route path="/free-advice" element={<FreeLegalAdvice />} />
            <Route path="/ask-a-free-question" element={<AskfreeQuestion />} />
            <Route
              path="/free-legal-advice-phone"
              element={<FreelegalAdvicePhone />}
            />
            <Route
              path="/:communityCatslug/:communitySerSlug"
              element={<LegalAdviceDetails />}
            />
            <Route
              path="/advice-question/:questionslug"
              element={<QuestionAnswereDetails />}
            />
            {/* <Route
            
            path="/:communityCatslug/:communitySerSlug/:questionslug"
            element={
              <QuestionAnswereDetails RendomTokenfetch={RendomTokenfetch} />
            }
          /> */}

            <Route path="/services" element={<Services />} />
            <Route path="/services/:category" element={<Service />} />
            <Route path="/service/:serviceSlug" element={<ServiceDetails />} />
            {/* <Route
              
              path="/service/:serviceSlug"
              element={<ServiceDetails2 RendomTokenfetch={RendomTokenfetch} />}
            /> */}
            <Route path="/checkout/:planslug" element={<CheckoutPlans />} />
            <Route path="/plans/:planslug" element={<PlanDetails />} />
            
            <Route path="/payment-methods" element={<PaymentMethods />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-feild" element={<PaymentFeild />} />
            <Route path="/payment-invalid-link" element={<PaymentInvalid />} />

            <Route
              path="/payment-response/:orderid"
              element={<PaymentResponse />}
            />

            <Route path="/p/:linkid" element={<PaymentLinkwork />} />
            <Route path="/payment-receipt" element={<PaymentReceipt />} />
            <Route path="/add-to-cart" element={<AddtoCart />} />
            <Route path="/checkout-demo" element={<CheckoutPlansdemo />} />

            {/* <Route
              path="/enquiry/:planid"
              element={<Enquery RendomTokenfetch={RendomTokenfetch} />}
            /> */}

            <Route path="/term-and-condition" element={<TermCondition />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/cancellation-refund-policy"
              element={<RefundPolicy />}
            />
            <Route path="/logout" element={<Logout />} />

            <Route
              path="/product-service-description"
              element={<ProductServiceDescription />}
            />

            <Route
              path="/wallet"
              element={
                <ProtectedRoute>
                  <Wallet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/passbook"
              element={
                <ProtectedRouteAfterVendor>
                  <Passbook />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/passbook-transaction-details/:transactionid"
              element={
                <ProtectedRouteAfterVendor>
                  <PassbookTransactionDetails />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/add-wallet"
              element={
                <ProtectedRouteAfterVendor>
                  <AddWallet />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/add-wallet-proceed"
              element={
                <ProtectedRouteAfterVendor>
                  <AddWalletProceed />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/wallet-transactions"
              element={
                <ProtectedRouteAfterVendor>
                  <WalletTransactions />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/wallet-transaction-details/:transactionid"
              element={
                <ProtectedRouteAfterVendor>
                  <WalletTransactionDetails />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/walletPayment-success"
              element={
                <ProtectedRouteAfterVendor>
                  <WalletPaymentSuccess />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/withdrawal-amount"
              element={
                <ProtectedRouteAfterVendor>
                  <WithdrawalAmount />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/withdrawal-transaction-details/:transactionid"
              element={
                <ProtectedRouteAfterVendor>
                  <WithdrawalTransactionDetails />
                </ProtectedRouteAfterVendor>
              }
            />

            <Route
              path="/login"
              element={
                <ProtectedLoginSign>
                  <Login RendomTokenfetch={RendomTokenfetch} />
                </ProtectedLoginSign>
              }
            />
            <Route
              path="/register"
              element={
                <ProtectedLoginSign>
                  <Signup />
                </ProtectedLoginSign>
              }
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* DeshBoard Routing Start */}
            <Route
              path="/lead-transaction-details/:leadid"
              element={
                <ProtectedRoute>
                  <LeadTransactionDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/single-leadtransaction-details/:orderid"
              element={
                <ProtectedRoute>
                  <SingleLeadTransactionDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/deshboard"
              element={
                <ProtectedRoute>
                  <Deshbard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/all-leads"
              element={
                <ProtectedRoute>
                  <AllCatServiceWiseLeads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/claim-leads"
              element={
                <ProtectedRoute>
                  <AllClaimLeads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/claim-details/:leadid"
              element={
                <ProtectedRoute>
                  <AllClaimLeadDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/leadAdd"
              element={
                <ProtectedRouteAfterVendor>
                  <LeadAdd />
                </ProtectedRouteAfterVendor>
              }
            />
            {/* <Route
            
            path="/lead-view"
            element={
              <ProtectedRouteAfterVendor>
                <LeadView
                 
                  RendomTokenfetch={RendomTokenfetch}
                />
              </ProtectedRouteAfterVendor>
            }
          /> */}
            <Route
              path="/my-assign-lead"
              element={
                <ProtectedRouteAfterVendor>
                  <LeadAssignView />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/news-paper-schedule"
              element={
                <ProtectedRouteAfterVendor>
                  <NewsPaperSchedule />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/news-paper-schedule-edit/:newsid"
              element={
                <ProtectedRouteAfterVendor>
                  <NewsPaperScheduleEdit />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/news-schedule-update/:newsid"
              element={
                <ProtectedRouteAfterVendor>
                  <NewsScheduleUpdate />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/news-paper-schedule-view/:newsid"
              element={
                <ProtectedRouteAfterVendor>
                  <NewsPaperScheduleView />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/news-paper-add-view"
              element={
                <ProtectedRouteAfterVendor>
                  <NewsPaperAddView />
                </ProtectedRouteAfterVendor>
              }
            />

            <Route
              path="/news-paper-add"
              element={
                <ProtectedRouteAfterVendor>
                  <NewsPaperAdd />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/account-details-update"
              element={
                <ProtectedRouteAfterVendor>
                  <AccountDetailsUpdate />
                </ProtectedRouteAfterVendor>
              }
            />

            <Route
              path="/lead-assing-details/:leadid"
              element={
                <ProtectedRoute>
                  <LeadAssignDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/task-details/:leadid"
              element={
                <ProtectedRoute>
                  <AllLeadtotalDetails RendomTokenfetch={RendomTokenfetch} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-working-lead"
              element={
                <ProtectedRouteAfterVendor>
                  <LeadsWorkingView />
                </ProtectedRouteAfterVendor>
              }
            />
            <Route
              path="/lead-working-details/:leadid"
              element={
                <ProtectedRoute>
                  <LeadWorkingDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/service-booking"
              element={
                <ProtectedRoute>
                  <Leads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/service-booking/:leadid"
              element={
                <ProtectedRoute>
                  <LeadDetails />
                </ProtectedRoute>
              }
            />

            <Route
              path="/user-submission"
              element={
                <ProtectedRoute>
                  <UserFormSubmission RendomTokenfetch={RendomTokenfetch} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/vendor-request"
              element={
                <ProtectedRoute>
                  <VendorRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/all-service-plans/:catid"
              element={
                <ProtectedRoute>
                  <AllServicePlans />
                </ProtectedRoute>
              }
            />
            <Route path="/service-plans/:catid" element={<ServicePlansAll />} />
            <Route path="/service-plans/" element={<ServicePlansAll />} />
            <Route
              path="/profile-edit"
              element={
                <ProtectedRoute>
                  <ProfileEdit />
                </ProtectedRoute>
              }
            />

            <Route path="/page-not-found" element={<PageNotFound />} />
            <Route
              path="*"
              element={<Navigate to="/page-not-found" replace />}
            />
            <Route path="/error" element={<ErrorPage />} />
          </Routes>
          <Footer RendomTokenfetch={RendomTokenfetch} />
        </Suspense>
      </Router>
    </>
  );
}

export default App;
